import React from 'react'
import { Page, Props as PageProps } from './Page'
import { PageSettingsSidebar } from './pageSettings/Sidebar'

type Props = Omit<PageProps, 'sidebar'>

export const PageSettings = (props: Props) => (
  <Page
    {...props}
    sidebar={<PageSettingsSidebar />}
  />
)
